export default "__VITE_ASSET__DDS2JiJv__"